import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { Table, Glyphicon, Row, Col, Pagination } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
class ReportingTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            activePage: 1,
            data: this.props.initialData,
            sortedColumn: 'none',
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.initialData,
        });
    }
    handleSelect(eventKey) {
        this.setState({
            activePage: eventKey,
        });
    }
    sortColumn(prop, isSorted) {
        return () => {
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { data: isSorted
                        ? prevState.data.reverse()
                        : _.sortBy(prevState.data, prop), sortedColumn: prop });
            });
        };
    }
    paginate(data) {
        const start = (this.state.activePage - 1) * this.props.paginateBy;
        const end = start + this.props.paginateBy;
        return data.slice(start, end);
    }
    render() {
        const { t } = this.props;
        if (!this.state.data.length) {
            return (React.createElement("div", null,
                React.createElement("p", { className: "lead" }, this.props.title),
                React.createElement("br", null),
                React.createElement("p", null, t('NO_RESULTS_TO_DISPLAY'))));
        }
        const headers = this.props.headers.map((header, index) => {
            var column = _.keys(this.state.data[0])[index];
            return (React.createElement("th", null,
                React.createElement("a", { onClick: this.sortColumn(column, this.state.sortedColumn === column) }, header)));
        });
        const rows = this.paginate(this.state.data).map((row, index) => {
            const columns = _(row).map((column) => {
                return React.createElement("td", null, column);
            });
            return React.createElement("tr", { key: index }, columns);
        });
        return (React.createElement("div", null,
            React.createElement("p", { className: "lead" }, this.props.title),
            React.createElement(Table, { bordered: true, hover: true, striped: true, responsive: true, className: "reporting-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null, headers)),
                React.createElement("tbody", null, rows)),
            React.createElement(Pagination, { first: true, last: true, bsSize: "medium", maxButtons: 10, items: Math.ceil(this.state.data.length / this.props.paginateBy), activePage: this.state.activePage, onSelect: (eventKey) => this.handleSelect(eventKey) })));
    }
}
ReportingTable.propTypes = {
    initialData: PropTypes.array.isRequired,
    headers: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    paginateBy: PropTypes.number,
};
ReportingTable.defaultProps = {
    paginateBy: 5,
};
export default withTranslation()(ReportingTable);
